// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"665":"53fbc1e9d012bdaee104","827":"b8168491e37e2ff17896"}[chunkId] + ".2146.js";
};